import { createBrowserRouter } from "react-router-dom";
import HomepageUser from "../Components/Users/Homepage";
import Dashboard from "../Components/Users/dashboard";

import {
  AdminNavbar,
  AdminLogin,
  ForgetPageLink,
  ForgetPassword,
} from "../Components/admin/index";

//users
import {
  BidderRegister,
  ShowAuctions,
  Reciept,
  RecieptForm,
  ContactUs,
  AboutUs,
  RegistrationForm,
} from "../Components/Users/pages";
//admin
import {
    AgencyDashboard,
  TenderWinnerRefund,
  EditRoles,
  CustomMisReport,
  MISActiveReport,
  CreateDepartment,
  EditViewEmp,
  CreateEmployee,
    ProfileManagement,
  CreateRoles,
  WinnerDeclartionForm,
  AuctionWinnerDeclartion,
  CreateAuction,
  AuctionRefund,
  AdminDashboard,
  ShowAuctionsAdmin,
  GenerateRefund,
  PaymentTable,
  BillFiles,
  FundAllotment,
  AdminPassKeys,
  OpenTenders,
  ClosedTenders,
  Authorization,
  RefundCheck,
  TenderCancelRefund,
  GenerateTenderCancelRefund,
  CustomerReciept,
  Report,
  UploadBill,
  VendorList,
  Budget,
  Banks,
  BillApprovals,
  VendorBills,
  LogReports,
  BudgetEstimation,
  BudgetHeadCreation,
  ReleasefromFinance,
  DemandApproval,
  DemandGeneration,
  CreateProject,
  CreateWorkOrder,
  CreateContractor,
  ProjectDashboard,
  ProjectList,
  ContractorList,
  BudgetHeadList,
  BudgetEstimationList,
  WorkOrderList,
  ViewDemandGeneration,
  BudgetHeadInwardList,
  ProjectInwardList,
  BudgetEstimationInwardList,
  ReleaseFromFinanceInwardList,
  WorkOrderInwardList,
  CreateAgency,
  AgencyOutwardList,
  CreateUser,
  FundOutwardList,
  ECSReport,
  ECSUpdate,
  ECSTransferFiles,
  FundCreation,
  FundInwardList,
  FundList,
  LimitAllocation,
  LimitAllocationInwardList,
  LimitAllocationOutwardList,
  MisReports,
} from "../Components/admin/pages/index";
import Taxes from "../Components/admin/pages/Master/Taxes/Taxes";
import VendorRegister from "../Components/admin/pages/Vendor Management/VendorRegister/VendorRegister";
import { Rates } from "../Components/admin/pages/Master";
import {
  AddProduct,
  PurchaseList,
} from "../Components/admin/pages/Inventory Management";
import {
  BudgetEstimationReport,
  BudgetHeadReport,
  ProjectReport,
  ReleasefromfinanceReport,
  VendorReport,
  WorkOrderReport,
} from "../Components/admin/pages/Report";
import { ReleaseFromFinanceHead } from "../Components/admin/pages/BudgetManagement";
import { ExpenditureDetails } from "../Components/admin/pages/Expenditure Details";
import ObjectCode from "../Components/admin/pages/Master/ObjectCode/ObjectCode";
import Mapfunction from "../Components/admin/pages/Mapfunction/MapFunction";
import { PrograseReportInwordList } from "../Components/admin/pages/PrograseReport";
import { PrograseReportOutwordList } from "../Components/admin/pages/PrograseReport";

let token = localStorage.getItem("Usertoken");

const router = createBrowserRouter([
  {
    path: "/AdminLogin",
    element: <AdminLogin />,
  },
  {
    path: "/ForgetPassword",
    element: <ForgetPassword />,
  },
  {
    path: "/ForgetPageLink/:Link",
    element: <ForgetPageLink />,
  },
  {
    path: "/AdminDashboard",
    element: <AdminNavbar />,
    children: [
      {
        path: "",
        element: <AdminDashboard />,
      },
      {
        path: "RefundCheck",
        element: <RefundCheck />,
      },
       {
        path: "AgencyDashboard",
        element: <AgencyDashboard />,
      },
      {
        path: "Authorization",
        element: <Authorization />,
      },

      {
        path: "EditRoles",
        element: <EditRoles />,
      },
      {
        path: "CustomMisReport",
        element: <CustomMisReport />,
      },
      {
        path: "MISActiveReport",
        element: <MISActiveReport />,
      },
      {
        path: "MisReports",
        element: <MisReports />,
      },
      {
        path: "CreateDepartment",
        element: <CreateDepartment />,
      },
      {
        path: "CreateEmployee",
        element: <CreateEmployee />,
      },
        {
        path: "ProfileManagement",
        element: <ProfileManagement />,
      },
      {
        path: "EditViewEmp",
        element: <EditViewEmp />,
      },
      {
        path: "CreateRoles",
        element: <CreateRoles />,
      },
      {
        path: "EditAuction",
        element: <ShowAuctionsAdmin />,
      },
      {
        path: "CreateAuction",
        element: <CreateAuction />,
      },
      {
        path: "TenderWinnerRefund",
        element: <TenderWinnerRefund />,
      },
      {
        path: "AuctionRefund",
        element: <AuctionRefund />,
      },
      {
        path: "TenderCancelRefund",
        element: <TenderCancelRefund />,
      },
      {
        path: "GenerateTenderCancelRefund/:id/:AuctionName",
        element: <GenerateTenderCancelRefund />,
      },
      {
        path: "AuctionWinnerDeclartion/",
        element: <AuctionWinnerDeclartion />,
      },
      {
        path: "WinnerDeclartionForm/:id",
        element: <WinnerDeclartionForm />,
      },
      {
        path: "GenerateRefund/:id/:AuctionName",
        element: <GenerateRefund />,
      },
      {
        path: "PaymentTable",
        element: <PaymentTable />,
      },
      {
        path: "BillFiles",
        element: <BillFiles />,
      },
      {
        path: "FundAllotment",
        element: <FundAllotment />,
      },
      {
        path: "AdminPassKeys",
        element: <AdminPassKeys />,
      },
      {
        path: "OpenTenders",
        element: <OpenTenders />,
      },
      {
        path: "ClosedTenders",
        element: <ClosedTenders />,
      },
      {
        path: "CustomerReciept",
        element: <CustomerReciept />,
      },
      {
        path: "Report",
        element: <Report />,
      },
      {
        path: "ProjectReport",
        element: <ProjectReport />,
      },
      {
        path: "BudgetHeadReport",
        element: <BudgetHeadReport />,
      },
      {
        path: "BudgetEstimationReport",
        element: <BudgetEstimationReport />,
      },
      {
        path: "WorkOrderReport",
        element: <WorkOrderReport />,
      },
      {
        path: "VendorReport",
        element: <VendorReport />,
      },
      {
        path: "ReleasefromfinanceReport",
        element: <ReleasefromfinanceReport />,
      },
      {
        path: "UploadBill",
        element: <UploadBill />,
      },
      {
        path: "VendorList",
        element: <VendorList />,
      },
      {
        path: "Budget",
        element: <Budget />,
      },
      {
        path: "Banks",
        element: <Banks />,
      },
      {
        path: "Rates",
        element: <Rates />,
      },
      {
        path: "BillApprovals",
        element: <BillApprovals />,
      },
      {
        path: "VendorBills",
        element: <VendorBills />,
      },
      {
        path: "Taxes",
        element: <Taxes />,
      },
      {
        path: "VendorRegister",
        element: <VendorRegister />,
      },
      {
        path: "LogReports",
        element: <LogReports />,
      },
      {
        path: "AddProduct",
        element: <AddProduct />,
      },
      {
        path: "PurchaseList",
        element: <PurchaseList />,
      },
      {
        path: "BudgetEstimation",
        element: <BudgetEstimation />,
      },
      {
        path: "BudgetHeadCreation",
        element: <BudgetHeadCreation />,
      },
      {
        path: "ReleasefromFinance",
        element: <ReleasefromFinance />,
      },
      {
        path: "DemandApproval",
        element: <DemandApproval />,
      },
      {
        path: "DemandGeneration",
        element: <DemandGeneration />,
      },
      {
        path: "CreateProject",
        element: <CreateProject />,
      },
      {
        path: "CreateWorkOrder",
        element: <CreateWorkOrder />,
      },
      {
        path: "CreateVendor",
        element: <CreateContractor />,
      },
      {
        path: "ProjectDashboard",
        element: <ProjectDashboard />,
      },
      {
        path: "ProjectList",
        element: <ProjectList />,
      },
      {
        path: "VendorList",
        element: <ContractorList />,
      },
      {
        path: "BudgetHeadList",
        element: <BudgetHeadList />,
      },
      {
        path: "BudgetEstimationList",
        element: <BudgetEstimationList />,
      },
      {
        path: "WorkOrderList",
        element: <WorkOrderList />,
      },
      {
        path: "ReleaseFromFinanceHead",
        element: <ReleaseFromFinanceHead />,
      },
      {
        path: "ExpenditureDetails",
        element: <ExpenditureDetails />,
      },
      {
        path: "ViewDemandGeneration",
        element: <ViewDemandGeneration />,
      },
      {
        path: "ObjectCode",
        element: <ObjectCode />,
      },
      {
        path: "WorkOrderInwardList",
        element: <WorkOrderInwardList />,
      },
      {
        path: "BudgetHeadInwardList",
        element: <BudgetHeadInwardList />,
      },
      {
        path: "ProjectInwardList",
        element: <ProjectInwardList />,
      },
      {
        path: "BudgetEstimationInwardList",
        element: <BudgetEstimationInwardList />,
      },
      {
        path: "ReleaseFromFinanceInwardList",
        element: <ReleaseFromFinanceInwardList />,
      },
      {
        path: "AgencyRegistration",
        element: <CreateAgency />,
      },
      {
        path: "AgencyOutwardList",
        element: <AgencyOutwardList />,
      },
      {
        path: "CreateUser",
        element: <CreateUser />,
      },
      {
        path: "FundOutwardList",
        element: <FundOutwardList />,
      },
      {
        path: "ECSReport",
        element: <ECSReport />,
      },
      {
        path: "ECSUpdate",
        element: <ECSUpdate />,
      },
      {
        path: "ECSTransferFiles",
        element: <ECSTransferFiles />,
      },
      {
        path: "FundCreation",
        element: <FundCreation />,
      },
      {
        path: "FundInwardList",
        element: <FundInwardList />,
      },
      {
        path: "FundList",
        element: <FundList />,
      },
      {
        path: "LimitAllocation",
        element: <LimitAllocation />,
      },
      {
        path: "LimitAllocationInwardList",
        element: <LimitAllocationInwardList />,
      },
      {
        path: "LimitAllocationOutwardList",
        element: <LimitAllocationOutwardList />,
      },
      {
        path: "Mapfunction/:id?",
        element: <Mapfunction />,
      },
      {
        path: "ProgressReportInwordList",
        element: <PrograseReportInwordList />,
      },
      {
        path: "ProgressReportOutwordList",
        element: <PrograseReportOutwordList />,
      },
    ],
  },
  {
    path: "/",
    element: <HomepageUser />,
    errorElement: <div>Sorry</div>,
  },
  {
    path: "/Dashboard",
    element: <Dashboard />,
    errorElement: <div>Sorry</div>,
    children: [
      // {
      //   path: "BidderRegister/:Auction_ID/:Auction_Name",
      //   element: <BidderRegister />,
      // },
      {
        path: "BidderRegister",
        element: <BidderRegister />,
      },
      {
        path: "ShowAuctions",
        element: <ShowAuctions />,
      },
      {
        path: "Reciept",
        element: <RecieptForm />,
      },
      {
        path: "RegistrationForm",
        element: <RegistrationForm />,
      },
      {
        path: "DownloadReciept/:tid/:gst/:panno",
        element: <Reciept />,
      },
      {
        path: "contactUs",
        element: <ContactUs />,
      },
      {
        path: "AboutUs",
        element: <AboutUs />,
      },
    ],
  },
]);

export default router;
